module.exports = __webpack_public_path__ + "static/media/asb_exa_ins.5e8b628e.png";